export function getSubdomain() {
  const host = window.location.hostname;
  const baseVar = window.location.protocol + "//" + host + "/api/v2/";
  return baseVar;
}

export function getApiBase() {
  return window.location.protocol + '//' + window.location.hostname + '/api/v2/';
}

export function getBaseDomain() {
  const host = window.location.hostname;
  return host.substring(host.indexOf('.') + 1);
}

export function getImageBase() {
  return window.location.protocol + '//' + window.location.hostname + '/';
}

// #1478 — apply headers to a raw XMLHttpRequest, skipping any value that is
// null/undefined or the literal strings "undefined"/"null". Mirrors the axios
// api.js request-interceptor sanitizer for the Drive preview/download/upload
// paths that use raw XHR (which bypass the axios interceptor entirely). Without
// this, setRequestHeader('cs3-context-role', undefined) coerces to the literal
// "undefined" and trips ValidateRoleHeader once #1432 flips to enforce.
export function safeSetXhrHeaders(xhr, headers) {
  Object.keys(headers || {}).forEach(function (key) {
    var v = headers[key];
    if (v === undefined || v === null || v === 'undefined' || v === 'null') return;
    xhr.setRequestHeader(key, v);
  });
}

export const global = [
    {
        'BASE_URL': getSubdomain(),
        'IMAGE_URL': getImageBase(),
        'CLIENT_BASE': getBaseDomain() + '/',
        'REPORT_URL': "https://reports.callsteward.com/"
    },
];
